import { render, staticRenderFns } from "./DashboardUpcoming.vue?vue&type=template&id=e3707e58&scoped=true"
import script from "./DashboardUpcoming.vue?vue&type=script&lang=js"
export * from "./DashboardUpcoming.vue?vue&type=script&lang=js"
import style0 from "./DashboardUpcoming.vue?vue&type=style&index=0&id=e3707e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3707e58",
  null
  
)

export default component.exports